// This is client side config only - keep secrets safe in .env
export const BASE_API_URL = `https://banks.data.fdic.gov/api`;
